import { render, staticRenderFns } from "./canteenForm.vue?vue&type=template&id=e1b1428e&"
import script from "./canteenForm.vue?vue&type=script&lang=js&"
export * from "./canteenForm.vue?vue&type=script&lang=js&"
import style0 from "./canteenForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports